import Header from './components/header';
import Sider from './components/sider';
import Footer from './components/footer';
import TabBar from './components/tabBar';
import RouteRenderer from './components/RouteRenderer';
import { Layout } from '@douyinfe/semi-ui';
import { usePrefixCls } from 'src/hook/useConfig';
import { useUserDataRefresh } from '@/hook/useUserDataRefresh';
import { VersionUpdateNotification } from '@/components/VersionUpdateNotification';
import './index.scss';

const { Content } = Layout;

const LayoutIndex = () => {
  const prefixCls = usePrefixCls('layout');

  // 使用自定义 hook 处理用户数据刷新
  useUserDataRefresh();

  return (
    <Layout className={prefixCls}>
      <Sider />
      <Layout className={'flex flex-col'}>
        <Header />
        <TabBar />
        <Content className={`${prefixCls}-content overflow-x-hidden`}>
          <RouteRenderer />
        </Content>
        <Footer />
      </Layout>
      <VersionUpdateNotification />
    </Layout>
  );
};

export default LayoutIndex;
